import React from "react";
//#region types
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { EntityIdParams } from "models/propTypes/urlParamsTypes";
//#endregion
//#region components
import {
  PageLayouts,
  useMountedState,
  useNavigationHistory,
  useAPIRequestKeyRef,
  EntityCardLayout,
  Skeletons,
  LoadingSuccess,
  useSuccessAnimation,
} from "components/common";
import { useParams } from "react-router-dom";
import { ErrorView } from "components/error";
import { useDocumentDraftService } from "serviceHooks";
import DocumentDraft from "./documentDraft";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import clsx from "clsx";
import { ServiceHelper } from "utils/helpers";

const DocumentDraftView: React.FC = () => {
  const documentDraftService = useDocumentDraftService();
  const urlParams = useParams<EntityIdParams>();
  const id = Number.parseInt(urlParams.id ?? "0");

  const { getMounted } = useMountedState();
  const { goBack } = useNavigationHistory();

  const [notFound, setNotFound] = React.useState<boolean>();
  const [documentDraft, setDocumentDraft] = React.useState<WintSuperkollAPIModel.DocumentDraft>();
  const [key, setKey] = React.useState(0);

  const { apiRequestKeyRef, updateKey } = useAPIRequestKeyRef();

  const loadDocumentDraft = (
    onSuccess?: (documentDraft: WintSuperkollAPIModel.DocumentDraft) => void,
    onError?: () => void
  ) => {
    const currentKey = updateKey();

    ServiceHelper.withAPIRequestKey(documentDraftService.get(id), currentKey)
      .then((result) => {
        if (getMounted() && result.key === apiRequestKeyRef.current) {
          setNotFound(false);
          setDocumentDraft(result.data);
          setKey(key + 1);
        }

        onSuccess && onSuccess(result.data);
      })
      .catch(() => {
        if (documentDraft) {
          setTimeout(() => {
            goBack();
          }, 1000);
          onError && onError();
        } else setNotFound(true);
      });
  };

  React.useEffect(() => {
    if (id) {
      setDocumentDraft(undefined);
      loadDocumentDraft();
    }
  }, [id]);

  const { showSuccess, onSuccess } = useSuccessAnimation(loadDocumentDraft);

  return notFound ? (
    <ErrorView />
  ) : (
    <>
      <PageLayouts.EntityFullScreen
        entityKey={`document-draft`}
        id={documentDraft?.id ?? 0}
        className={clsx(cssExports.transparent, cssExports.cardNavigation)}
      >
        <>
          {showSuccess ? <LoadingSuccess /> : <></>}
          <EntityCardLayout>
            {documentDraft ? (
              <DocumentDraft key={key} documentDraft={documentDraft} reloadHandler={onSuccess} />
            ) : (
              <Skeletons.EntityCardSkeleton hasInfoViewer />
            )}
          </EntityCardLayout>
        </>
      </PageLayouts.EntityFullScreen>
    </>
  );
};

export default DocumentDraftView;
